import { BaseService } from '@common/http-layer/service/base.service'

import type { LocationFeatureFlagsResponse } from '../types/location-feature-flags'

/**
 * Temporary Client Portal preview-cache feature-flags client for Levelup-2026.
 * Delete with `useLevelUp2026` after launch.
 *
 * GET `/clientportal-preview-cache/internal/locations/:locationId/feature-flags`
 */
export class LocationFeatureFlagsService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '/clientportal-preview-cache/internal/locations',
      serviceName: 'LocationFeatureFlagsService',
    })
  }

  async fetchFeatureFlags(locationId: string): Promise<LocationFeatureFlagsResponse> {
    const { data } = await this.get<LocationFeatureFlagsResponse>(`/${encodeURIComponent(locationId)}/feature-flags`, {
      locationId,
    })
    return data
  }
}
